"use strict";
import { VERSION as b } from "./index.es128.js";
import r from "./index.es130.js";
const u = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, t) => {
  u[n] = function(e) {
    return typeof e === n || "a" + (t < 1 ? "n " : " ") + n;
  };
});
const l = {};
u.transitional = function(n, t, e) {
  function s(i, o) {
    return "[Axios v" + b + "] Transitional option '" + i + "'" + o + (e ? ". " + e : "");
  }
  return (i, o, a) => {
    if (n === !1)
      throw new r(
        s(o, " has been removed" + (t ? " in " + t : "")),
        r.ERR_DEPRECATED
      );
    return t && !l[o] && (l[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(i, o, a) : !0;
  };
};
u.spelling = function(n) {
  return (t, e) => (console.warn(`${e} is likely a misspelling of ${n}`), !0);
};
function p(n, t, e) {
  if (typeof n != "object")
    throw new r("options must be an object", r.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(n);
  let i = s.length;
  for (; i-- > 0; ) {
    const o = s[i], a = t[o];
    if (a) {
      const c = n[o], f = c === void 0 || a(c, o, n);
      if (f !== !0)
        throw new r("option " + o + " must be " + f, r.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (e !== !0)
      throw new r("Unknown option " + o, r.ERR_BAD_OPTION);
  }
}
const E = {
  assertOptions: p,
  validators: u
};
export {
  E as default
};
//# sourceMappingURL=index.es239.js.map
